<div class="title-bar">
  <ion-icon name="bulb" color="tertiary" class="icon" />

  <h4>Hint {{ index() + 1 }}</h4>
</div>

<ion-button
  color="light"
  fill="clear"
  size="small"
  class="btn-close"
  (click)="dismiss()"
>
  <ion-icon name="close" slot="icon-only" />
</ion-button>

<div class="content">
  <p [innerHTML]="hint().value | displayMath"></p>
</div>
